module.exports = __webpack_public_path__ + "img/blau-grün fertig ausschnitt.9f8448f5.jpg";